import {Connection} from '../../app/DTOs/Connection.component';
import {StopObject} from '../../app/DTOs/StopObject.component';
import {LineObject} from '../../app/DTOs/LineObject.component';
import {ItinerarioObject} from '../../app/DTOs/ItinerarioObject.component';
import {NextDeparture} from '../../app/DTOs/NextDeparture.component';
import {LiveBus} from '../../app/DTOs/LiveBus.component';
import { Expevisit } from './Expevisit.component';

declare var colorCity: any;

export class ObjectManager {
	constructor() {
	}


	private id: string;
	private name: string;
	private lat: string;
	private lon: string;
	private connections: Connection[] = [];

	public getLinesArrayFromJson(json) {
		const linesArray: LineObject[] = [];
		let itinerariosArray: ItinerarioObject[] = [];

		for (let i = 0; i < json.lines.length; i++) {

			itinerariosArray = this.getItinerariesArrayFromJson(json.lines[i].outgoing);

			linesArray.push(new LineObject(
				json.lines[i].id,
				json.lines[i].name,
				json.lines[i].surname,
				json.lines[i].number,
				json.lines[i].color,
				itinerariosArray
			));
		}
		return linesArray;
	}

	public getItinerariesArrayFromJson(json) {
		var itinerariosArray: ItinerarioObject[] = [];
		var stopsArray: StopObject[] = [];
		for (var i = 0; i < json.length; i++) {
			stopsArray = this.getStopsArrayFromJson(json[i].stops);
			itinerariosArray.push(new ItinerarioObject(
				json[i].idIti,
				json[i].id_linea,
				json[i].nombreIti.replace('xOBRAS',''),
				json[i].lineHeader,
				json[i].lineEnd,
				stopsArray
			));
		}
		return itinerariosArray;
	}

	public getStopsArrayFromJson(json) {
		var stopsArray: StopObject[] = [];
		for (var i = 0; i < json.length; i++) {
			stopsArray.push(new StopObject(
				json[i].id,
				json[i].code,
				json[i].name,
				json[i].lat,
				json[i].lon,
				json[i].connections
			));
		}
		stopsArray.sort(function (a, b) { return a.getCode() - b.getCode(); });
		return stopsArray;
	}

	// Las devuelve ordenadas por horas
	public getNextDeparturesFromJson(json) {
		let actualId = 0;
		let nextDeparturesArray: NextDeparture[] = [];
		for (let i = 0; i < json.length; i++) {
			let departureExpedition: Expevisit;
			for (let expIt = 0; expIt < json[i].expevisit.length; expIt++) {
				if(json[i].expevisit[expIt].visit === 0){
					departureExpedition = new Expevisit(
						json[i].expevisit[expIt].expedicion,
						json[i].expevisit[expIt].visit
					);
				}
			}
			for (let x = 0; x < json[i].time.length; x++) {
				json[i].time[x] = json[i].time[x].substring(0, 5);
				let nextDeparture = new NextDeparture(
					actualId,
					json[i].id,
					json[i].name,
					departureExpedition,
					json[i].destino,
					json[i].color,
					json[i].time[x],
					json[i].time[x].replace(':', '')
				);
				nextDeparture.setEstimationTime('N/A');
				nextDeparturesArray.push(nextDeparture);
				actualId++;
			}
		}

		// Ordenamos el array por horas
		nextDeparturesArray.sort(function (a, b) {
			return a.getTimeValue() - b.getTimeValue();
		});
		return nextDeparturesArray;
	}

	// El servicio las devuelve en radianes sus mu
	public getLiveBusesArrayFromJson(json) {
		var liveBusesArray: LiveBus[] = [];
		// Los buses vienen dentro del objeto GEO
		var jsonBuses = json.geo;
		for (var i = 0; i < jsonBuses.length; i++) {
			liveBusesArray.push(new LiveBus(
				jsonBuses[i].id,
				colorCity,
				this.coordenadasRadianesADecimales(jsonBuses[i].lat),
				this.coordenadasRadianesADecimales(jsonBuses[i].lon),
				true
			));
		}
		return liveBusesArray;
	}

	public coordenadasRadianesADecimales(coordenadaConcreta) {
		return coordenadaConcreta * (180 / Math.PI);
	}
}



// WEBPACK FOOTER //
// ./src/app/DTOs/ObjectManager.component.ts